export type StoryblokVersion = 'published' | 'draft'

/**
 * Determines the Storyblok API version to use.
 *
 * Production traffic should use published content. Next.js Draft Mode opts a
 * single editor session into draft content without affecting the ISR cache for
 * regular visitors.
 */
export function getStoryblokVersion(isDraftMode = false): StoryblokVersion {
  if (isDraftMode) {
    return 'draft'
  }

  const envVersion = process.env.STORYBLOK_VERSION
  if (envVersion === 'published' || envVersion === 'draft') {
    return envVersion
  }

  return 'published'
}
